/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Created_ToInputs */



/**
* | output |
* | --- |
* | "Created to" |
*
* @param {Explorer_Search_Created_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_created_to = /** @type {((inputs?: Explorer_Search_Created_ToInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Created_ToInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "de") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "it") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "es") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Created to")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Created to")
	return /** @type {LocalizedString} */ ("Created to")
});